import { render, staticRenderFns } from "./DuplicateIncidentsTable.vue?vue&type=template&id=0a8f2b2e&"
import script from "./DuplicateIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./DuplicateIncidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateIncidentsTable.vue?vue&type=style&index=0&id=0a8f2b2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports